import { render, staticRenderFns } from "./OportunidadesForm.vue?vue&type=template&id=261308e2&"
import script from "./OportunidadesForm.vue?vue&type=script&lang=js&"
export * from "./OportunidadesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports